import React from "react";
import { Alert, Backdrop, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Snackbar, TextField, useTheme } from "@mui/material";
import { t } from "../i18n";
import { dialogSx, fieldSx, primaryButtonSx, secondaryButtonSx } from "../uiStyles";

export default function SkeletonDialogs({
  currentLocale,
  changePassOpen,
  confirmChangeOpen,
  oldPassword,
  newPassword,
  confirmPassword,
  loading,
  snackbar,
  isChangeNextDisabled,
  onCancel,
  onOldPasswordChange,
  onNewPasswordChange,
  onConfirmPasswordChange,
  onChangePasswordNext,
  onConfirmChangePassword,
  onCloseSnackbar,
}) {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const passwordFieldSx = { mt: 1, ...fieldSx(isDark) };
  const themedPrimaryButtonSx = isDark
    ? {
        ...primaryButtonSx,
        bgcolor: "#7a746b",
        '&:hover': { bgcolor: '#625d56', boxShadow: 'none' },
        '&.Mui-disabled': { bgcolor: 'rgba(122,116,107,0.42)', color: 'rgba(255,255,255,0.82)', boxShadow: 'none' },
      }
    : primaryButtonSx;
  const themedSecondaryButtonSx = isDark ? { ...secondaryButtonSx, color: "rgba(226,232,240,0.88)" } : secondaryButtonSx;

  return (
    <>
      <Dialog open={changePassOpen} onClose={onCancel} sx={dialogSx}>
        <DialogTitle>{t("password.title", currentLocale)}</DialogTitle>
        <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2, minWidth: 320, pt: 1 }}>
          <TextField label={t("password.current", currentLocale)} type="password" value={oldPassword} onChange={onOldPasswordChange} fullWidth sx={passwordFieldSx} />
          <TextField label={t("password.new", currentLocale)} type="password" value={newPassword} onChange={onNewPasswordChange} fullWidth sx={passwordFieldSx} />
          <TextField label={t("password.repeat", currentLocale)} type="password" value={confirmPassword} onChange={onConfirmPasswordChange} fullWidth sx={passwordFieldSx} />
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2.5 }}>
          <Button onClick={onCancel} sx={themedSecondaryButtonSx}>{t("common.cancel", currentLocale)}</Button>
          <Button onClick={onChangePasswordNext} variant="contained" sx={themedPrimaryButtonSx} disabled={isChangeNextDisabled}>{t("common.next", currentLocale)}</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={confirmChangeOpen} onClose={onCancel} sx={dialogSx}>
        <DialogTitle>{t("password.confirmTitle", currentLocale)}</DialogTitle>
        <DialogContent>
          <DialogContentText>{t("password.confirmText", currentLocale)}</DialogContentText>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2.5 }}>
          <Button onClick={onCancel} sx={themedSecondaryButtonSx}>{t("common.cancel", currentLocale)}</Button>
          <Button onClick={onConfirmChangePassword} variant="contained" sx={themedPrimaryButtonSx}>{t("common.confirm", currentLocale)}</Button>
        </DialogActions>
      </Dialog>

      <Backdrop open={loading} sx={{ zIndex: 1300, color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={onCloseSnackbar} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
        <Alert onClose={onCloseSnackbar} severity={snackbar.severity} sx={{ width: "100%" }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
}
